import { Button } from 'antd'
import React from 'react'
import { useTableContext } from './TableProvider'
import { useTranslation } from 'react-i18next'
import { PlusOutlined } from '@ant-design/icons'

const TableAddButton: React.FC = () => {
  const { handleAddRecord, displayAddBtn = false, disableTableControl = false } = useTableContext()
  const { t } = useTranslation()
  if (!displayAddBtn || disableTableControl) {
    return <React.Fragment />
  }
  return (
    <Button icon={<PlusOutlined />} style={{ width: 102 }} type='primary' onClick={handleAddRecord}>
      {t('common:add')}
    </Button>
  )
}

export default TableAddButton
